import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { FormSubmission } from '../../../types/FormSubmission';
import { mutationKeys } from '../mutationKeys';
import _ from 'lodash';

type Payload = FormSubmission & { submit?: boolean };

const updateFormSubmission = async (uuid: string | undefined, formData: Payload) => {
  if (!uuid) return null;

  const response = await CustomAxios.put(`form_submissions/${uuid}`, _.pick(formData, ['fields', 'submit']));
  const { data } = response;
  return data;
};

interface UseUpdateFormSubmissionProps {
  uuid?: string;
  onSuccessCallback?: (data: FormSubmission) => void;
}

export function useUpdateFormSubmission({ uuid, onSuccessCallback }: UseUpdateFormSubmissionProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateFormSubmission],
    mutationFn: (formData: Payload) => updateFormSubmission(uuid, formData),
    onSuccess: (data: FormSubmission) => {
      // fetch again after update
      queryClient.invalidateQueries({ queryKey: [queryKeys.allFormSubmissions, data.uuid] });

      // call success
      onSuccessCallback?.(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const formSubmission: FormSubmission = err.response.data as FormSubmission;
        queryClient.setQueryData([queryKeys.allFormSubmissions, formSubmission.uuid], formSubmission);
      }
    },
  });
}
